<div class="mainWrap container">
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark">

      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item active">
              <a class="nav-link" href="http://www.michigan.gov/mpsc/">Home
              <span class="sr-only">(current)</span>
            </a>
          </li>         
        </ul>
      </div>
      <div class="nav navbar-nav">
        <a class="navbar-brand miGovHome" href="http://www.michigan.gov" title="Michigan's Official Web Site">MI.gov</a>
      </div>
    </nav>
  
    <header class="header" role="banner">
      <div class="container">
        <a href="http://www.michigan.gov/mpsc/" class="home-link">
          
          <img class="logo" src="../UtilityForms/assets/images/logo.png" alt="Agency Logo" id="logo"/>
          <div class="pull-left">
            <h1 class="siteTitle" data-som-header="appTitle">{{title}}</h1>
            <span class="tagline" data-som-header="agencyTagLine">{{tagline}}</span>
          </div>
        </a>
      </div>
    </header>
    <main id="main" role="main" class="main">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <router-outlet></router-outlet>           
          </div>
        </div>
      </div>
    </main>
    <footer role="contentinfo" class="footer">
      <div class="container">
        <ul class="footerNav" id="footer">
          <li>
            <a href="http://www.michigan.gov" title="Michigan's Official Web Site">MI.gov</a>
          </li>
          <li *ngIf="(title=='Damage Prevention Complaint Form')  ">
              <a href="https://www.michigan.gov/lara">Lara Home</a>
            </li>

          <li *ngIf="((title == 'LCSA Tax Credit Application') ||(title == 'Video Survey Provider') ||(title == 'Video Survey Franchise') ||(title == 'Armccm') ||(title=='Leo') ||(title=='Damage Prevention Complaint Form') )  ">
              <a href="http://www.michigan.gov/mpsc/">MPSC Home</a>
            </li>

            <li *ngIf="((title == 'Economic Leaders in Energy Efficiency') ||(title == 'State Energy Program Planning RFI'))  ">
                <a href="http://www.michigan.gov/energy/">Energy Home</a>
              </li>

          <li>
            <a href="http://www.michigan.gov/policies">Policies</a>
          </li>       
          

          <li>
            <a href="#body" class="visible-xs visible-sm">Back to Top</a>
          </li>


        </ul>
        <p class="hidden-xs">Copyright
          <span id="currentYear">{{copyrightYear}}</span> State of Michigan</p>          
      </div>
    </footer>
  </div>
  
  <!-- Modal -->
  <div id="mainModal" class="modal fade" role="complementary">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h2 id="mainModalTitle" class="modal-title">Template Application</h2>
        </div>
        <div id="mainModalBody" class="modal-body"></div>
      </div>
    </div>
  </div>
